export default __webpack_public_path__ + "static/media/bg-driveways.ca2ccd8c.jpg";